// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22hj4","questions":"styles_questions__iFZvV","footer":"styles_footer__GcSwt"};